export enum CriteriaType {
    Chart = "Chart",
    Integer = "Integer",
    TextField = "TextField",
    RichTextEditor = "RichTextEditor",
}
